/** Mock policy detail — field names aligned with MedicalBack Policy/Data.vue.
 *  Live endpoints: PolicyById, PolicyException, Program, Group, PolicyCard
 */

export function getPolicyDetailMock(policyId) {
  const id = String(policyId || "1");
  const num = Number(id) || 1;
  const policyFullNumber = `PL-2026-${String(100000 + num).slice(-6)}`;
  return {
    policyId: id,
    medicalPolicy: {
      policyId: id,
      policyFullNumber,
      policyDateStr: "15.03.2026",
      branchName: "Bakı",
      startDateStr: "01.04.2026",
      endDateStr: "31.03.2027",
      cancelDateStr: "",
      cancelTypeName: "",
      cancelReason: "",
      currency: "AZN",
      insured: {
        name: "HÜSEYNOVA LEYLA RAMİZ QIZI",
        address: "SUMQAYIT ŞƏHƏRİ, SÜLH KÜÇƏSİ",
        phone: "+994501234567",
      },
      beneficiary: {
        name: "HÜSEYNOVA LEYLA RAMİZ QIZI",
        address: "SUMQAYIT ŞƏHƏRİ, SÜLH KÜÇƏSİ",
      },
      invoice: {
        invoiceNumber: "INV-2026-00042",
        invoiceLink: "",
      },
    },
    adminCharge: "5%",
    limitPremium: "30 gün",
    sellerLogin: "agent.user",
    exceptions: [
      {
        groupName: "Ailə",
        exceptName: "Stomatologiya (planlaşdırılmış)",
        caseCount: 2,
        countLimitTypeName: "İllik",
        caseSum: 500,
        sumLimitTypeName: "Xidmət üzrə",
        useTypeName: "Polis üzrə",
        franchise: "10%",
        notes: "",
      },
      {
        groupName: "Ailə",
        exceptName: "Kosmetologiya",
        caseCount: 0,
        countLimitTypeName: "—",
        caseSum: 0,
        sumLimitTypeName: "—",
        useTypeName: "—",
        franchise: "—",
        notes: "İstisna",
      },
    ],
    programs: [
      {
        programName: "Ambulator",
        countLimit: 12,
        sumLimit: 5000,
        franchise: "0%",
        limitScopeName: "İllik",
      },
      {
        programName: "Stasionar",
        countLimit: 2,
        sumLimit: 15000,
        franchise: "10%",
        limitScopeName: "Hadisə üzrə",
      },
    ],
    groups: [
      {
        groupName: "Ailə",
        insSum: 50000,
        premium: 1200,
        sumScopeName: "İllik limit",
        descrHtml: "Qrup üzrə ümumi şərtlər.",
      },
      {
        groupName: "VIP",
        insSum: 100000,
        premium: 3500,
        sumScopeName: "İllik limit",
        descrHtml: "",
      },
    ],
    insuredCards: [
      {
        cardFullNumber: "CR-000101",
        insuredName: "HÜSEYNOVA LEYLA RAMİZ QIZI",
        groupName: "Ailə",
        cardStatusName: "Aktiv",
        sexStr: "Q",
        startDateStr: "01.04.2026",
        endDateStr: "31.03.2027",
        dobStr: "22.08.2001",
      },
    ],
  };
}
